import Vue from 'vue'
import axios from 'axios'
import { processAthlete } from '@/store/modules/athletes/detail'

// state
export const state = {
  isMatchEventsLoading: false,
  all: {},
}

// getters
export const getters = {
  getMatchEvents: ({ all }) => (matchId) => all[matchId] || null,
}
// mutations
export const mutations = {
  fetchMatchEventsStarted(state) {
    state.isMatchEventsLoading = true
  },
  fetchMatchEventsSuccess(state, { matchId, events }) {
    Vue.set(state.all, matchId, events.map((event) => {
      return {
        ...event,
        performance: event.performance && {
          ...event.performance,
          athlete: processAthlete(event.performance.athlete),
        },
      }
    }))
    state.isMatchEventsLoading = false
  },
  fetchMatchEventsFailed(state) {
    state.isMatchEventsLoading = false
  },
}
// actions
export const actions = {
  async fetchMatchEvents({ commit, getters }, { matchId }) {
    let events = getters.getMatchEvents(matchId)
    if (events) {
      return events
    }
    try {
      commit('fetchMatchEventsStarted')
      events = await axios.get(`match/${matchId}/events`)
      commit('fetchMatchEventsSuccess', {
        matchId,
        events,
      })
    } catch (e) {
      commit('fetchMatchEventsFailed')
    }
    return events
  },
}
